module.exports = __webpack_public_path__ + "static/feat-work-2-b5e66555c705eaee13544db7d462f480.svg";